import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, Input, ModalFooter, Button } from 'reactstrap'
import s from './CreateChecklistTemplateModal.scss'
import { ChecklistsContainer } from './ChecklistsContainer'
import { v4 as uuidv4 } from 'uuid'

const CreateChecklistTemplateModal = ({
  isModalVisible,
  clearModal,
  editedTemplate,
  toggleModal,
  saveTemplate
}) => {
  const [name, setName] = useState('')
  const [visibility, setVisibility] = useState('ALL')
  const [prevEditedTemplate, setPrevEditedTemplate] = useState(null)
  const [checklists, setChecklists] = useState([])

  if (editedTemplate && editedTemplate !== prevEditedTemplate) {
    setName(editedTemplate.name)
    setVisibility(editedTemplate.visibility)
    setPrevEditedTemplate(editedTemplate)
    setChecklists(
      editedTemplate.checkLists.map(checklist => ({
        id: checklist.id,
        title: checklist.title,
        items: checklist.items.map(item => ({ id: item.id, name: item.name }))
      }))
    )
  }

  const createChecklist = async title => {
    setChecklists([...checklists, { id: uuidv4(), title, items: [] }])
  }

  const updateChecklist = async (title, id) => {
    setChecklists(
      checklists.map(checklist => {
        if (checklist.id === id) {
          return { ...checklist, title }
        }
        return checklist
      })
    )
  }

  const updateItem = async (title, id, checklistId) => {
    setChecklists(
      checklists.map(checklist => {
        if (checklist.id === checklistId) {
          return {
            ...checklist,
            items: checklist.items.map(item => {
              if (item.id === id) {
                return { ...item, name: title }
              }
              return item
            })
          }
        }
        return checklist
      })
    )
  }

  const deleteItem = async (checklistId, itemId) => {
    setChecklists(
      checklists.map(checklist => {
        if (checklist.id === checklistId) {
          return {
            ...checklist,
            items: checklist.items.filter(item => item.id !== itemId)
          }
        }
        return checklist
      })
    )
  }

  const addItem = async (checklistId, itemName) => {
    setChecklists(
      checklists.map(checklist => {
        if (checklist.id === checklistId) {
          return {
            ...checklist,
            items: [...checklist.items, { id: uuidv4(), name: itemName }]
          }
        }
        return checklist
      })
    )
  }

  const deleteChecklist = async id => {
    setChecklists(checklists.filter(checklist => checklist.id !== id))
  }

  const createTemplate = async () => {
    const template = editedTemplate
      ? {
          id: editedTemplate.id,
          name,
          visibility,
          checkLists: checklists.map(checklist => ({
            ...(typeof checklist.id === 'number' ? { id: checklist.id } : {}),
            title: checklist.title,
            items: checklist.items.map(item => ({
              ...(typeof item.id === 'number' ? { id: item.id } : {}),
              name: item.name
            }))
          }))
        }
      : {
          name,
          visibility,
          checkLists: checklists.map(checklist => ({
            title: checklist.title,
            items: checklist.items.map(item => item.name)
          }))
        }

    saveTemplate(template)
    setChecklists([])
  }

  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={isModalVisible}
      toggle={clearModal}
      size="xl"
      className={s.modal}
    >
      <ModalHeader className={s.modalHeader}>
        {editedTemplate ? 'Edit' : 'Add'} Checklist Template
      </ModalHeader>
      <ModalBody className={s.modalBody}>
        <div style={{ marginBottom: '20px' }}>
          <Input
            type="text"
            onChange={({ target }) => setName(target.value)}
            value={name}
            name="name"
            placeholder="Template Name"
            className={s.input}
          />
          <div className={s.radioGroup}>
            <label>Visible</label>
            <input
              type="radio"
              checked={visibility === 'ALL'}
              onChange={() => {
                setVisibility('ALL')
              }}
            />{' '}
            Everyone in my org {'  '}
            <input
              type="radio"
              checked={visibility === 'ME'}
              onChange={() => {
                setVisibility('ME')
              }}
              className={s.rightRadio}
            />{' '}
            Just me
          </div>
        </div>
        <ChecklistsContainer
          checklists={checklists}
          createChecklist={createChecklist}
          updateChecklist={updateChecklist}
          addItem={addItem}
          deleteItem={deleteItem}
          deleteChecklist={deleteChecklist}
          updateItem={updateItem}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          className={s.saveBtn}
          onClick={createTemplate}
          disabled={!name || !checklists.length}
        >
          Save
        </Button>
        <Button
          color="secondary"
          onClick={() => {
            toggleModal()
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default CreateChecklistTemplateModal
